<section data-step="2" class="step">
    <div class="newchapter">
        <h1 class="chapter">II.  <i class="mark green">De spelregels</i></h1>
        <h2 class="chaptersubtitle">Klaar voor de start?</h2>
    </div>

    <div class="row">
        <div class="twelve columns">
            <p>Er zijn op dit moment drie sets spelregels die gaan over de studiefinanciering. De eerste was de “Basisbeurs” tussen 2010 en 2015. Op dit moment geldt voor nieuwe studenten het “Leenstelsel”, welke in 2015 is gestart. En nieuwe studenten die in 2023 gaan studeren vallen onder de “Nieuwe Basisbeurs” die in dat jaar gaat starten. <br/>
                <br/> De spelregels zijn zo ingericht dat wat je betaalt afhankelijk is van wat je verdient. De overheid vraagt je daarom een percentage te betalen van wat je _boven_ een minimumbedrag verdient. Dit is per set spelregels net iets anders. <br/>
                <br/> De spelregels beschermen je als je een hoge schuld hebt, maar met je studie geen baan hebt kunnen vinden waarmee je veel kunt verdienen. <br/>
                </p>
        </div>
    </div>
    <div class="row">
        <div class="twelve columns">
            <h2>Basisbeurs <span class="small">vs</span> leenstelsel <span class="small">vs</span> basisbeurs</h2>
            <p>We gaan weer terug* naar de basisbeurs! Althans, als je in 2023 nog studeert. Het is eigenlijk ook niet echt <i>terug</i> naar de basisbeurs, want de drie sets spelregels verschillen veel van elkaar. Hier de belangrijkste kenmerken en verschillen:</p>
        </div>
    </div>

    <div class="row nobg comparison">
        <div class="stickycol four columns ">
            <div class="sticky">
            <h2>Basisbeurs</h2>
            <ul>
                <li class="heading">Onderdelen</li>
                <li>Collegegeldkrediet</li>
                <li>Lening</li>
                <li>Studentenreisproduct</li>
                <li>Aanvullende beurs</li>
                <li>Basisbeurs</li>
            </ul>
            <ul>
                <li class="heading">Prodedure</li>
                <li class="subheading">OPBOUWFASE</li>
                <li>Maximaal 7 jaar lenen</li>
                <li>Prestatiebeurs 10 jaar</li>
                <li class="subheading">AANLOOPFASE</li>
                <li>Maximaal 2 jaar</li>
                <li class="subheading">AFLOSFASE</li>
                <li>Maximaal 15 jaar</li>
                <li class="subheading">BETALING PER MAAND</li>
                <li>Minimaal 12% van loon <br/> boven minimumloon</li>
            </ul>
            </div>
        </div>
        <div class="stickycol four columns">
            <div class="sticky">
                <h2>Leenstelsel</h2>
            <ul>
                <li class="heading">Onderdelen</li>
                <li>Collegegeldkrediet</li>
                <li>Lening</li>
                <li>Studentenreisproduct</li>
                <li>Aanvullende beurs</li>
                <li class="empty">&nbsp;</li>
            </ul>
            <ul>
                <li class="heading">Prodedure</li>
                <li class="subheading">OPBOUWFASE</li>
                <li>Maximaal 7 jaar lenen</li>
                <li>Prestatiebeurs 10 jaar</li>
                <li class="subheading">AANLOOPFASE</li>
                <li>Maximaal 2 jaar</li>
                <li class="subheading">AFLOSFASE</li>
                <li>Maximaal 35 jaar</li>
                <li class="subheading">BETALING PER MAAND</li>
                <li>Minimaal 4% van loon <br/> boven modaal inkomen</li>
            </ul>
        </div></div>
        <div class="stickycol four columns">
            <div class="sticky">
            <h2>Basisbeurs v2</h2>
            <ul>
                <li class="heading">Onderdelen</li>
                <li>Collegegeldkrediet</li>
                <li>Lening</li>
                <li>Studentenreisproduct</li>
                <li>Aanvullende beurs</li>
                <li>Basisbeurs</li>
            </ul>
            <ul>
                <li class="heading">Prodedure</li>
                <li class="subheading">OPBOUWFASE</li>
                <li>Maximaal 7 jaar lenen</li>
                <li>Prestatiebeurs 10 jaar</li>
                <li class="subheading">AANLOOPFASE</li>
                <li>Maximaal 2 jaar</li>
                <li class="subheading">AFLOSFASE</li>
                <li>Maximaal 35 jaar</li>
                <li class="subheading">BETALING PER MAAND</li>
                <li>Minimaal 4% van loon <br/> boven modaal inkomen</li>
            </ul>
        </div> </div>
        
    </div> <!-- END COMPARISON DIVS-->

    <div class="row">
        <div class="twelve columns">
            <p>Dat was de basis van wat je moet weten van de studiefinanciering. Maar er is nog veel meer! Hoe werkt rente eigenlijk? Hoeveel moet ik nu echt gaan betalen?!
            <br/>Dat zijn voorbeelden die je waarschijnlijk (net als ik) beter snapt als je ermee kunt spelen. Scroll snel verder! </p>
        </div>
    </div>
</section>